export default "__VITE_ASSET__7397921d__"